import { ButtonWithDropdown } from "@risalabs_frontend_org/oasis-ui-kit";
import {
  NarAgentGridBulkToggleAction,
  NAR_AGENT_GRID_BULK_TOGGLE_BUTTON_LABEL,
  NAR_AGENT_GRID_BULK_TOGGLE_MENU_ITEMS,
} from "../utils/narAgentGridBulkToggleActions";

interface NarAgentGridBulkToggleMenuProps {
  disabled: boolean;
  onAction: (action: NarAgentGridBulkToggleAction) => void;
}

/**
 * Renders the Bulk Toggle header dropdown for selected NAR Agent Grid rows.
 */
const NarAgentGridBulkToggleMenu = ({
  disabled,
  onAction,
}: NarAgentGridBulkToggleMenuProps) => {
  return (
    <ButtonWithDropdown
      alwaysOpenDropdown
      buttonType="secondary"
      disabled={disabled}
      menuData={NAR_AGENT_GRID_BULK_TOGGLE_MENU_ITEMS.map((item) => ({
        id: item.id,
        label: item.label,
        onClick: () => onAction(item.id),
      }))}
      onButtonClick={() => undefined}
      onClick={() => undefined}
      size="medium"
    >
      {NAR_AGENT_GRID_BULK_TOGGLE_BUTTON_LABEL}
    </ButtonWithDropdown>
  );
};

export default NarAgentGridBulkToggleMenu;
